module.exports = __webpack_public_path__ + "img/help30.dde5b116.png";